import useSSR from "use-ssr";

const { isServer } = useSSR();

/**
 * Application-level error message handler
 * @param errorMessage
 * @param level
 */
export const logError = (errorMessage, level = "error") => {
	// Only send to Sentry if we're in the browser and Sentry is available
	// Check isServer because window is not available on the server
	if (!isServer && window.Sentry) {
		Sentry.captureMessage(errorMessage, { level });
	} else {
		// Only log to console when Sentry is not available because console errors are sent to Sentry
		console.error(errorMessage);
	}
};
